import _ from 'lodash'
import Vue from 'vue'
import { Auth } from './auth'
import axios from 'axios'
import moment from 'moment'
import { nSQL } from "@nano-sql/core"

const API_URL = process.env.VUE_APP_COALISTE_API_URL;
//Update the list every 30 seconds
const AUTO_PULL_SOLICITATION_ASSIGNATIONS_DELAY = 30000;
const AUTO_PULL_SOLICITATION_LISTS_DELAY = 30000;
const AUTO_PUSH_DIRECT_SCORINGS_DELAY = 10000;
const MY_SOLICITATION_ASSIGNATIONS_URL = API_URL + 'my/solicitation-assignations';
const SOLICITATION_ASSIGNATIONS_STATS_URL = API_URL + 'solicitation-assignations/{solicitationAssignationId}/stats';
const SOLICITATION_LISTS_URL = API_URL + 'solicitation-assignations/{solicitationAssignationId}/effective-solicitation-lists';
const SOLICITATION_LIST_BATCHES_URL = API_URL + 'solicitation-assignations/{solicitationAssignationId}/solicitation-list-batches';
const SOLICITATION_VOTERS_URL = API_URL + 'solicitation-assignations/{solicitationAssignationId}/effective-solicited-voters';
const MY_DIRECT_SCORING_BATCHES_URL = API_URL + 'my/direct-scoring-batches';
const PULL_SOLICITATION_LISTS_FLUSH = 100;

export const Exchanger = new Vue({
  data: {
    offline: false,
    initialized: false,

    pullSolicitationAssignationsInterval: null,
    pullSolicitationAssignationsReady: true,

    pullSolicitationAssignationStatsReady: [],

    pullSolicitationListsInterval: null,
    pullSolicitationListsReady: [],

    pushSolicitationListsInterval: null,
    pushSolicitationListsReady: [],

    pushDirectScoringsInterval: null,
    pushDirectScoringsReady: true,
  },

  methods: {
    init: function () {
      if (this.initialized) {
        return false;
      }

      this.initialized = true;

      this.startAutoPullSolicitationAssignations();
      this.startAutoPullSolicitationLists();
      // this.startAutoPushDirectScorings();
    },

    onOffline() {
      console.log('go offline');
      this.offline = true;
    },

    onOnline() {
      console.log('go online');
      this.offline = false;
    },

    isOffline() {
      return this.offline === true;
    },

    pushSolicitationLists: async function (solicitationAssignation) {
      const isReady = typeof this.pushSolicitationListsReady[solicitationAssignation.id] === 'undefined'
        ? true
        : this.pushSolicitationListsReady[solicitationAssignation.id];

      if (! isReady || ! Auth.isAuthenticated() || this.isOffline()) {
        return false;
      }

      this.pushSolicitationListsReady[solicitationAssignation.id] = false;

      let matchedSolicitationLists = await nSQL('solicitation_lists')
        .query('select')
        .where(function (sl) {
          return sl.solicitation_assignation_id === solicitationAssignation.id
            && sl.locally_updated_at > sl.pulled_at
            && (! sl.pushed_at || sl.pushed_at < sl.locally_updated_at)
        })
        .exec();

      const solicitationLists = matchedSolicitationLists.slice(0, 300);

      const pushedAt = moment();
      const pushedSolicitationListRecords = [];

      for (let i = 0, len = solicitationLists.length; i < len; i++) {
        let solicitationList = solicitationLists[i];

        pushedSolicitationListRecords.push({
          local_id: solicitationList.local_id,
          pushed_at: pushedAt.valueOf(),
        });
      }

      await nSQL('solicitation_lists')
        .query("upsert", pushedSolicitationListRecords)
        .exec();

      let settingRecord = {
        name: 'solicitation-assignations:' + solicitationAssignation.id + ':pushed_at',
        value: pushedAt.valueOf(),
      };

      await nSQL('settings')
        .query("upsert", settingRecord)
        .exec()
        .then(function () {
          console.log(`Stats metric pushed_at of solicitation assignation ${solicitationAssignation.id} has been defined as ${pushedAt.valueOf()}.`);
        }.bind(this));

      const endpoint = SOLICITATION_LIST_BATCHES_URL.replace('{solicitationAssignationId}', solicitationAssignation.id);

      const response = await axios.post(endpoint, solicitationLists, {
        headers: { 'Authorization': 'Bearer ' + Auth.user().token }
      }).catch(function() {
        return false;
      });

      if (response.status === 201) {
        // If not, maybe revert
      }

      this.$emit('solicitation-lists-pushed', solicitationAssignation);

      this.pushSolicitationListsReady[solicitationAssignation.id] = true;

      return true;
    },

    toDateTime(timestamp) {
      return (timestamp || timestamp === 0)
        ? moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
        : null;
    },

    toTimestamp(dateTime) {
      return dateTime
        ? moment(dateTime, 'YYYY-MM-DD HH:mm:ss').valueOf()
        : null;
    },

    startAutoPullSolicitationAssignations: function () {
      this.stopAutoPullSolicitationAssignations();

      this.pullSolicitationAssignationsInterval = setInterval(
        this.pullSolicitationAssignations,
        AUTO_PULL_SOLICITATION_ASSIGNATIONS_DELAY
      );
    },

    stopAutoPullSolicitationAssignations: function () {
      clearInterval(this.pullSolicitationAssignationsInterval);
    },

    toLocalSolicitationAssignation: function (solicitationAssignation) {
      return Object.assign({}, solicitationAssignation, {
        "date_start": this.toTimestamp(solicitationAssignation.date_start),
        "date_end": this.toTimestamp(solicitationAssignation.date_end),
      });
    },

    toSolicitationAssignation: function (localSolicitationAssignation) {
      return Object.assign({}, localSolicitationAssignation, {
        "date_start": this.toDateTime(localSolicitationAssignation.date_start),
        "date_end": this.toDateTime(localSolicitationAssignation.date_end),
      });
    },

    saveSolicitationAssignation: async function (solicitationAssignation) {
      const solicitationAssignationRecord = this.toLocalSolicitationAssignation(solicitationAssignation);

      return await nSQL('solicitation_assignations')
        .query("upsert", solicitationAssignationRecord)
        .exec();
    },

    pullSolicitationAssignations: async function () {
      if (! this.pullSolicitationAssignationsReady || ! Auth.isAuthenticated() || this.isOffline()) {
        return false;
      }

      console.log('Pulling solicitation assignations.');
      this.pullSolicitationAssignationsReady = false;

      try {
        const response = await axios.get(MY_SOLICITATION_ASSIGNATIONS_URL, {
          headers: { 'Authorization': 'Bearer ' + Auth.user().token }
        });

        if (response.status === 200) {
          const pulledAt = moment();

          let idSolicitation = await this.getAllValidIdsFromTable('solicitation_assignations');

          let pulledSolicitation = [];
          for (let i = 0, len = response.data.length; i < len; i++) {
            let solicitationAssignation = response.data[i];
            pulledSolicitation.push(solicitationAssignation.id);

            solicitationAssignation.pulled_at = pulledAt.valueOf();
            solicitationAssignation.remotely_deleted = false;

            await this.saveSolicitationAssignation(solicitationAssignation);
          }

          let idDiff = idSolicitation.filter(x => !pulledSolicitation.includes(x));
          await this.eraseAllIdsFromTable('solicitation_assignations', idDiff);
          console.log('Solicitations cleaned');

          await nSQL('solicitation_assignations')
            .query('upsert', {remotely_deleted: true, pulled_at: pulledAt.valueOf()})
            .where(['pulled_at', '<', pulledAt.valueOf()])
            .exec()
        }else if (response.status === 400){
            console.log('All campains has been removed')
            //All campains has been removed from my list need to erase and change the UI
        }
      } catch (error) {
        console.error(error);
      }

      this.pullSolicitationAssignationsReady = true;

      this.$emit('solicitation-assignations-pulled');

      console.log('Pulled solicitation assignations.');
    },

    startAutoPullSolicitationLists: function () {
      this.stopAutoPullSolicitationLists();

      this.pullSolicitationListsInterval = setInterval(
        this.pullSolicitationLists,
        AUTO_PULL_SOLICITATION_LISTS_DELAY
      );
    },

    stopAutoPullSolicitationLists: function () {
      clearInterval(this.pullSolicitationListsInterval);
    },

    toLocalSolicitationList: function (solicitationList) {
      return Object.assign({}, solicitationList, {
        "last_call_at": this.toTimestamp(solicitationList.last_call_at),
        "solicitation_date": this.toTimestamp(solicitationList.solicitation_date),
        "vote_date": this.toTimestamp(solicitationList.vote_date),
        "phone_household": solicitationList.format_phone_household.replace( /\D+/g, '') || null,
        "phone_principal": solicitationList.format_phone_principal.replace( /\D+/g, '') || null,
      });
    },

    toSolicitationList: function (localSolicitationList) {
      return Object.assign({}, localSolicitationList, {
          "last_call_at": this.toDateTime(localSolicitationList.last_call_at),
          "solicitation_date": this.toDateTime(localSolicitationList.solicitation_date),
          "vote_date": this.toDateTime(localSolicitationList.vote_date),
      });
    },

    saveSolicitationList: async function (solicitationList) {
      const solicitationListRecord = this.toLocalSolicitationList(solicitationList);

      solicitationListRecord.local_id = [
        solicitationList.solicitation_assignation_id,
        solicitationList.voter_id,
      ].join('-');

      // Saving
      return await nSQL('solicitation_lists')
        .query("upsert", solicitationListRecord)
        .exec();
    },

    toLocalSolicitedVoter: function (solicitedVoter) {
      return Object.assign({}, solicitedVoter, {
        "rankingDate": this.toTimestamp(solicitedVoter.rankingDate),
        "updated_at": this.toTimestamp(solicitedVoter.updated_at),
      });
    },

    toSolicitedVoter: function (localSolicitedVoter) {
      return Object.assign({}, localSolicitedVoter, {
          "rankingDate": this.toDateTime(localSolicitedVoter.rankingDate),
          "updated_at": this.toDateTime(localSolicitedVoter.updated_at),
      });
    },

    getAllValidIdsFromTable: async function(table){
      const ids = [];

      let results =
        await
        nSQL(table)
        .query('select')
        .exec();

        for (let i = 0, len = results.length; i < len; i++){
          ids.push(results[i].id);
        }
        return ids;
    },

    eraseAllIdsFromTable: async function(table, ids){
        for (let i = 0, len = ids.length; i < len; i++){
            await nSQL(table)
              .query("delete")
              .where(["id","=",ids[i]])
              .exec();
        }
    },

    saveSolicitedVoter: async function (solicitedVoter) {
      const solicitedVoterRecord = this.toLocalSolicitedVoter(solicitedVoter);

      // console.log('Saving solicited voter record:');
      // console.log(solicitedVoterRecord);

      // Saving
      return await nSQL('solicited_voters')
        .query("upsert", solicitedVoterRecord)
        .exec();
    },

    pullSolicitationAssignationStats: async function (solicitationAssignation) {
      const isReady = typeof this.pullSolicitationAssignationStatsReady[solicitationAssignation.id] === 'undefined'
        ? true
        : this.pullSolicitationAssignationStatsReady[solicitationAssignation.id];

      if (! isReady || ! Auth.isAuthenticated() || this.isOffline()) {
        return false;
      }

      this.pullSolicitationAssignationStatsReady[solicitationAssignation.id] = false;

      const endpoint = SOLICITATION_ASSIGNATIONS_STATS_URL.replace('{solicitationAssignationId}', solicitationAssignation.id);

      const response = await axios.get(endpoint, {
        headers: { 'Authorization': 'Bearer ' + Auth.user().token }
      });

      if (response.status === 200) {
        for (let i = 0, len = response.data.length; i < len; i++) {
          let statItem = response.data[i];

          let settingRecord = {
            name: 'solicitation-assignations:' + solicitationAssignation.id + ':' + statItem.metric,
            value: statItem.value,
          };

          await nSQL('settings')
            .query("upsert", settingRecord)
            .exec()
            .then(function () {
              console.log(`Stats metric ${statItem.metric} of solicitation assignation ${solicitationAssignation.id} has been defined as ${statItem.value}.`);
            }.bind(this));
        }

        this.$emit('solicitation-assignation-stats-pulled', solicitationAssignation);
      }

      this.pullSolicitationAssignationStatsReady[solicitationAssignation.id] = true;
    },
    pullSolicitationLists: async function (solicitationAssignation) {
      const isReady = solicitationAssignation || typeof this.pullSolicitationListsReady[solicitationAssignation.id] === 'undefined'
        ? true
        : this.pullSolicitationListsReady[solicitationAssignation.id];

      if (! isReady || ! Auth.isAuthenticated() || this.isOffline()) {
        return false;
      }

      console.log('Pulling solicitation lists.');
      this.pullSolicitationListsReady[solicitationAssignation.id] = false;

      this.pullSolicitationAssignationStats(solicitationAssignation);

      let isSolicitedVotersPulled = false;
      let pulledSolicitedVoters = [];

      let isSolicitationListsPulled = false;
      let pulledSolicitationLists = [];

      const me = this;

      async function attemptStartSyncing () {
        if (! isSolicitedVotersPulled || ! isSolicitationListsPulled) {
          return;
        }

        console.log('Syncing pulled...');

        //When we fetch a new DB, we first gather all the ID's we have in the DB to isolate those that
        //arent there anymore, so we can erase those not present
        let dbVotersId = await me.getAllValidIdsFromTable('solicited_voters');

        //Stored Id of those pulled
        let pulledVotersId = [];
        for (let i = 0, len = pulledSolicitedVoters.length; i < len; i++) {
          let solicitedVoter = pulledSolicitedVoters[i];
          pulledVotersId.push(solicitedVoter.id);

          const solicitedVoterRecord = (await nSQL('solicited_voters')
            .query('select')
            .where(["id", "=", solicitedVoter.id])
            .exec())[0] || null;

          if (! solicitedVoterRecord || me.toTimestamp(solicitedVoter.updated_at) > solicitedVoterRecord.updated_at ) {
            solicitedVoter.pulled_at = moment().valueOf();
            await me.saveSolicitedVoter(solicitedVoter);
          }
        }

        //Now that we have the Ids of our Database and those we received from the framework
        //We calculate the diff and erase those that we didn't received from the framework
        let idDiff = dbVotersId.filter(x => !pulledVotersId.includes(x));
        // console.log(idDiff);
        await me.eraseAllIdsFromTable('solicited_voters', idDiff);

        const pulledAt = moment();

        for (let i = 0, len = pulledSolicitationLists.length; i < len; i++) {
          if (i % PULL_SOLICITATION_LISTS_FLUSH === 0) {
            me.$emit('solicitation-lists-pulled', solicitationAssignation);
          }

          let solicitationList = pulledSolicitationLists[i];
          solicitationList.solicitation_assignation_id = solicitationAssignation.id;
          solicitationList.local_id = [solicitationAssignation.id, solicitationList.voter_id].join('-');

          const solicitationListRecord = (await nSQL('solicitation_lists')
            .query('select')
            .where(["local_id", "=", solicitationList.local_id])
            .exec())[0] || null;

          if (! solicitationListRecord
            || ! solicitationListRecord.locally_updated_at
            || solicitationListRecord.locally_updated_at <= solicitationListRecord.pulled_at
          ) {
            solicitationList.pulled_at = pulledAt.valueOf();
            solicitationList.remotely_deleted = false;

            await me.saveSolicitationList(solicitationList);
          }
        }

        console.log('Set obsolete solicitation lists as remotely deleted.');
        await nSQL('solicitation_lists')
          .query('upsert', {remotely_deleted: true, pulled_at: pulledAt.valueOf()})
          .where(sl =>
            sl.solicitation_assignation_id === solicitationAssignation.id
            && sl.pulled_at
            && sl.pulled_at < pulledAt.valueOf()
            && (! sl.locally_updated_at || sl.locally_updated_at <= sl.pulled_at)
          )
          .exec();

        let pulledAtSettingRecord = {
          name: `solicitation-assignations:${solicitationAssignation.id}:pulled_at`,
          value: pulledAt.valueOf(),
        };

        await nSQL('settings')
          .query("upsert", pulledAtSettingRecord)
          .exec()
          .then(function () {
            console.log(`Pulled at of solicitation assignation ${solicitationAssignation.id} has been defined as ${pulledAtSettingRecord.value}.`);
          });

        me.pullSolicitationListsReady[solicitationAssignation.id] = true;

        me.$emit('solicitation-lists-pulled', solicitationAssignation);

        console.log('Pulled solicitation lists.');
      }

      const solicitedVotersEndpoint = SOLICITATION_VOTERS_URL.replace('{solicitationAssignationId}', solicitationAssignation.id);

      axios.get(solicitedVotersEndpoint, {
        headers: { 'Authorization': 'Bearer ' + Auth.user().token }
      })
        .then(function (solicitedVotersResponse) {
          if (solicitedVotersResponse.status === 200) {
            pulledSolicitedVoters = solicitedVotersResponse.data;
            isSolicitedVotersPulled = true;
            attemptStartSyncing();
          }
        })
        .catch(function (error) {
          console.error(error);
        });

      const solicitationListsEndpoint = SOLICITATION_LISTS_URL.replace('{solicitationAssignationId}', solicitationAssignation.id);

      axios.get(solicitationListsEndpoint, {
        headers: { 'Authorization': 'Bearer ' + Auth.user().token }
      })
        .then(function (solicitationListsResponse) {
          if (solicitationListsResponse.status === 200) {
            pulledSolicitationLists = solicitationListsResponse.data;
            isSolicitationListsPulled = true;
            attemptStartSyncing();
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    startAutoPushDirectScorings: function () {
      this.stopAutoPushDirectScorings();

      this.pushDirectScoringsInterval = setInterval(
        this.pushDirectScorings,
        AUTO_PUSH_DIRECT_SCORINGS_DELAY
      );
    },

    stopAutoPushDirectScorings: function () {
      clearInterval(this.pushDirectScoringsInterval);
    },

    pushDirectScorings: async function () {
      if (! this.pushDirectScoringsReady || ! Auth.isAuthenticated() || this.isOffline()) {
        return false;
      }

      console.log('Pushing direct scorings.');

      let matchedToSyncDirectScoringRecords = await nSQL('direct_scorings')
        .query('select')
        .where(ds =>
          ds.locally_deleted !== true
          && (ds.locally_updated_at > ds.pushed_at || ! ds.pushed_at)
        )
        .exec();

      const toSyncDirectScoringRecords = matchedToSyncDirectScoringRecords.slice(0, 10);

      if (toSyncDirectScoringRecords.length === 0) {
        console.log('There is no direct scorings to push.');
        return;
      }

      this.pushDirectScoringsReady = false;

      const pushDirectScoringBatches = [];

      for (let i = 0, len = toSyncDirectScoringRecords.length; i < len; i++) {
        let toSyncDirectScoringRecord = toSyncDirectScoringRecords[i];
        let pushDirectScoring = Object.assign({}, toSyncDirectScoringRecord, {
          locally_updated_at: this.toDateTime(toSyncDirectScoringRecord.locally_updated_at),
          pushed_at: toSyncDirectScoringRecord.pushed_at ? this.toDateTime(toSyncDirectScoringRecord.pushed_at) : null,
        });

        pushDirectScoringBatches.push(pushDirectScoring);
      }

      console.log('Push ' + toSyncDirectScoringRecords.length + ' direct scorings.');

      try {
        const response = await axios.post(MY_DIRECT_SCORING_BATCHES_URL, pushDirectScoringBatches, {
          headers: { 'Authorization': 'Bearer ' + Auth.user().token }
        });

        // TODO unauthenticated fallback to login

        if (response.status === 201) {
          const affectedLocalIds = _.map(response.data, 'local_id');
          const pushedAt = moment();

          await nSQL('direct_scorings')
            .query('upsert', {pushed_at: pushedAt.valueOf()})
            .where(['local_id', 'IN', affectedLocalIds])
            .exec();

          this.$emit('direct-scorings-pushed');
        }
      } catch (error) {
        console.error(error);
      }

      this.pushDirectScoringsReady = true;

      console.log('Pushed direct scorings.');
    },
  }
});
